import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, input, ChangeDetectionStrategy, inject, computed } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { Account } from '@personal-area/global/accounts/models';
import { BonusTimeLeft } from '@personal-area/common';
import { FixRateCurrencyConverterPipe } from '@personal-area/global/accounts/utils';
import { MoneyPipe } from '@personal-area/global/billing/utils';
import { I18nService } from '@personal-area/global/i18n';
import { ButtonComponent, CardWrapperModule } from '@personal-area/global/ui';
import { DepositBonusTermsDialogComponent } from '../deposit-bonus-terms-dialog/deposit-bonus-terms-dialog.component';

@Component({
  selector: 'global-deposit-bonus-panel',
  standalone: true,
  imports: [
    ButtonComponent,
    CardWrapperModule,
    FixRateCurrencyConverterPipe,
    MoneyPipe,
    TranslateModule,
    DatePipe,
    CurrencyPipe,
  ],
  templateUrl: './deposit-bonus-panel.component.html',
  styleUrl: './deposit-bonus-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepositBonusPanelComponent {
  private _dialog = inject(MatDialog);
  private _i18nService = inject(I18nService);

  public wasReceived = input.required<boolean>();
  public link = input.required<string>();
  public account = input.required<Account>();
  public depositBonusExpirationDate = input.required<string>();
  public daysLeft = input.required<number>();
  public bonusTimeLeft = input.required<BonusTimeLeft>();
  public hasDatePassed = computed(() => {
    return new Date(this.depositBonusExpirationDate()).getTime() < Date.now();
  });

  public openDepositBonusTerms(): void {
    this._dialog.open(DepositBonusTermsDialogComponent, {
      direction: this._i18nService.isRtl ? 'rtl' : 'ltr',
      data: {
        wasFirstBonusReceived: this.wasReceived(),
        termsLink: this.link(),
        fromDeposit: false,
      },
    });
  }
}
